import useAuth from "./useAuth";
import { axiosAuth } from '../api/axios';

const useLogout = () => {
    const { setAuth, setUserData } = useAuth();

    const logout = async () => {
        
        // Grab the token before clearing it, so sign-out revokes it on the API.
        const token = localStorage.getItem('aT');
        try {
            localStorage.removeItem('aT');
            localStorage.removeItem('us-Id');
            setAuth({});
            setUserData({});
            if (token) {
                await axiosAuth.post('/auth/sign-out', {}, {
                    headers: { 'Authorization': 'Bearer ' + token }
                });
            }
        } catch (err) {
            console.error(err);
        }
    } 

    return logout;
}

export default useLogout;